// @ts-expect-error
import type {DragHandleProps} from 'react-beautiful-dnd';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {Card} from '../card/card';
// @ts-expect-error - imported from .js/.jsx file
import {DragHandleIcon} from '../icon/svg/drag-handle-icon';

import styles from './draggable-row-on-hover.module.css';

type Props = {
    children: any;
    dragHandleProps?: DragHandleProps;
    disableHover?: boolean;
    isActive?: boolean;
    onHoverBegin: () => void;
    onHoverEnd: () => void;
    isHovered: boolean;
};

export function DraggableRowOnHover(props: Props) {
    const mainContent =
        props.isHovered || props.isActive ? (
            <Card hasBorder={false} hasShadow={false}>
                <div className={styles['draggable-row']}>
                    <div
                        {...props.dragHandleProps}
                        data-tip='Drag to move'
                        data-place='left'
                        className={classnames(
                            styles['drag-handle'],
                            props.dragHandleProps?.className
                        )}
                    >
                        <DragHandleIcon size={14} />
                        <ReactTooltip delayShow={300} className='react-tooltip' effect='solid' />
                    </div>
                    <div className={styles['content--hovered']}>{props.children}</div>
                </div>
            </Card>
        ) : (
            // Drag handle props aren't actually used here, but if we don't pass
            // them, we get a long and nasty console error
            <div {...props.dragHandleProps}>{props.children}</div>
        );

    return (
        <div
            onMouseEnter={props.disableHover ? undefined : () => props.onHoverBegin()}
            onMouseLeave={() => props.onHoverEnd()}
        >
            <div className={props.isHovered || props.isActive ? undefined : styles.content}>
                {mainContent}
            </div>
        </div>
    );
}
